import { MergeField, MergeSchema, getSchema } from '../../decorators';
import { ActivityEntityName, Allocation, ContactEntity, Entity } from '../../../../entities';
import { ContactMergeData, ContactMergeSchema } from './contact.merge.data';
import { DateUtility } from '@jms/model/utilities';

@MergeSchema({
    entity: ActivityEntityName.Allocation,
    name: 'AllocationMergeSchema',
})
export class AllocationMergeData {

    @MergeField()
    _id: string;

    @MergeField()
    startDate: Date;

    @MergeField()
    endDate: Date;

    @MergeField({
        hidden: true
    })
    dateCompleted: Date;

    @MergeField({
        hidden: true
    })
    completedNote: string;

    @MergeField()
    note: string;

    @MergeField()
    status: string;

    @MergeField()
    type: string;

    @MergeField()
    bookingStatus: string;

    @MergeField()
    source: string;

    job?: Entity;
    workOrder?: Entity;
    opportunity?: Entity;
    resourceRaw?: ContactEntity;

    @MergeField({
        nestedFieldSchema: ContactMergeSchema
    })
    resource?: ContactMergeData;

    timezone?: string;
}

export const AllocationMergeSchema = getSchema(AllocationMergeData);

export class AllocationArrayMergeData {
    @MergeField({
        arraySchemaName: 'AllocationMergeSchema',
    })
    allocations: AllocationMergeData[];
}

export const AllocationArrayMergeSchema = getSchema(AllocationArrayMergeData);

export const transformAllocationToMergeData = (allocation: Allocation, contact: ContactMergeData, timezone: string): AllocationMergeData => {

    const mergeData = <AllocationMergeData>{
        startDate: allocation.startDate ? DateUtility.getTimezoneIndependentDateTime(allocation.startDate, timezone).toJSDate() : null,
        endDate: allocation.endDate ? DateUtility.getTimezoneIndependentDateTime(allocation.endDate, timezone).toJSDate() : null,
        dateCompleted: allocation.dateCompleted ? DateUtility.getTimezoneIndependentDateTime(allocation.dateCompleted, timezone).toJSDate() : null,
        completedNote: allocation.completedNote,
        note: allocation.note,
        status: allocation.status,
        type: allocation.type,
        bookingStatus: allocation.bookingStatus,
        source: allocation.source,
        resource: contact,
        timezone: timezone,
    };

    return mergeData;
}